import {
  GroupedRetailers,
  MAX_RETAILER_COUNT,
  retailerLabel,
  sortRetailers,
} from '@features/campaigns/subdomains/cpg';
import {
  performanceByTopRetailersSlide,
  PerformanceByTopRetailersSlideProps,
} from './performance-by-top-retailers-slide';
import { DEFAULT_SLIDE_MASTER } from '@features/lci-report/slides/slide-master';

const RETAILERS_PER_PAGE = 10;

type PerformanceByTopRetailersSlidesProps = Pick<
  PerformanceByTopRetailersSlideProps,
  'recommendation' | 'excludedColumns'
> & {
  groupedRetailers: GroupedRetailers<
    PerformanceByTopRetailersSlideProps['retailers'][number]
  >;
  overallRetailer: PerformanceByTopRetailersSlideProps['retailers'][number];
};

export const performanceByTopRetailersSlides = (
  props: PerformanceByTopRetailersSlidesProps
) => {
  const { groupedRetailers, overallRetailer, ...restProps } = props;

  const topRetailers = groupedRetailers.topRetailers
    .toSorted(sortRetailers)
    .slice(0, MAX_RETAILER_COUNT)
    .map((retailer, index) => ({
      ...retailer,
      ranking: index + 1,
    }));

  const slideCount = Math.ceil(topRetailers.length / RETAILERS_PER_PAGE);

  return Array.from({ length: slideCount }, (_, index) => {
    const start = index * RETAILERS_PER_PAGE;
    const end = start + RETAILERS_PER_PAGE;
    const currentRetailers = topRetailers.slice(start, end);

    return performanceByTopRetailersSlide({
      ...restProps,
      page: index + 1,
      totalPages: slideCount,
      slideMaster: DEFAULT_SLIDE_MASTER,
      retailers: [
        ...(index === 0 ? [overallRetailer] : []),
        ...currentRetailers,
        ...(index === slideCount - 1 && groupedRetailers.otherRetailer
          ? [groupedRetailers.otherRetailer]
          : []),
      ].map(retailer => ({
        ...retailer,
        name: retailerLabel(retailer.name),
      })),
    });
  });
};
